import React from "react";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardSanzioneService from "./dashboardSanzioneService";
import { getFormatInputFirstYear, getFormatOraInput, getFormatOraInputFirst } from "../../../common/utils";
import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default class DashboardSanzione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sanzioniGiornaliere: 0,
      sanzioniMensili: 0,
      sanzioniAnnue: 0,
      ingiunzioniGiornaliere: 0,
      ingiunzioniMensili:0,
      ingiunzioniAnnue:0,
      totaleDaIncassare: 0,
      totaleIncassato: 0,
      loading: true,
      datiGuadagni:[
        { name: 'Incassato', value: 50 },
        { name: 'Da Incassare', value: 30 },
      ],
      datiSanzioni:[
        {name:'Giornaliere', emesse: 0},
        {name:'Mensili', emesse: 0},
        {name:'Annue', emesse: 0}
      ],
      datiIngiunzioni:[
        {name:'Giornaliere', generate: 0},
        {name:'Mensili', generate: 0},
        {name:'Annue', generate: 0}
      ],
      fetchIngiunzioni:0,
      fetchSanzioni:0,
      loadingGraficoSanzioni:true,
      loadingGraficoIngiunzioni:true,
    };
     this.fetchCounter = 0;
    this.dashboardSanzioneService = new DashboardSanzioneService();
    this.COLORS = ['#FFBA13', '#1358ff',];
    this.RADIAN = Math.PI / 180;
  }

   renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * this.RADIAN);
    const y = cy + radius * Math.sin(-midAngle * this.RADIAN);
  
    return (
      <text x={x} y={y} fill="black" className="fw-bold" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };
  async componentDidMount() {
     this.dashboardSanzioneService.getTotaleSanzioniByTime(Date.parse(getFormatOraInput(Date.now())), (Date.parse(getFormatOraInput(Date.now())) + 86399000), async (result) => {
      this.setState({ sanzioniGiornaliere: result });
      this.state.datiSanzioni[0] = { ...this.state.datiSanzioni[0], emesse: result };
      this.setState({ datiSanzioni: this.state.datiSanzioni, });
      this.setState((prevState)=>{
        return {fetchSanzioni:prevState.fetchSanzioni+1}
      })
    });
     this.dashboardSanzioneService.getTotaleSanzioniByTime(Date.parse(getFormatOraInputFirst(Date.now())), Date.now(), (result) => {
      this.setState({ sanzioniMensili: result });
      this.state.datiSanzioni[1] = { ...this.state.datiSanzioni[1], emesse: result };
      this.setState({ datiSanzioni: this.state.datiSanzioni, });
      this.setState((prevState)=>{
        return {fetchSanzioni:prevState.fetchSanzioni+1}
      })
    });
    this.dashboardSanzioneService.getTotaleSanzioniByTime(Date.parse(getFormatInputFirstYear(Date.now())), Date.now(), (result) => {
      this.setState({ sanzioniAnnue: result });
      this.state.datiSanzioni[2] = { ...this.state.datiSanzioni[2], emesse: result };
      this.setState({ datiSanzioni: this.state.datiSanzioni, });
      this.setState((prevState)=>{
        return {fetchSanzioni:prevState.fetchSanzioni+1}
      })
    });
    this.dashboardSanzioneService.getTotaleIngiunzioniByTime(Date.parse(getFormatOraInput(Date.now())), (Date.parse(getFormatOraInput(Date.now())) + 86399000), (result) => {
      this.setState({ ingiunzioniGiornaliere: result });
      this.state.datiIngiunzioni[0] = { ...this.state.datiIngiunzioni[0], generate: result };
      this.setState({ datiIngiunzioni: this.state.datiIngiunzioni, });
      this.setState((prevState)=>{
        return {fetchIngiunzioni:prevState.fetchIngiunzioni+1}
      })
    });
    this.dashboardSanzioneService.getTotaleIngiunzioniByTime(Date.parse(getFormatOraInputFirst(Date.now())), Date.now(), (result) => {
      this.setState({ ingiunzioniMensili: result });
      this.state.datiIngiunzioni[1] = { ...this.state.datiIngiunzioni[1], generate: result };
      this.setState({ datiIngiunzioni: this.state.datiIngiunzioni, });
      this.setState((prevState)=>{
        return {fetchIngiunzioni:prevState.fetchIngiunzioni+1}
      })
    });
    this.dashboardSanzioneService.getTotaleIngiunzioniByTime(Date.parse(getFormatInputFirstYear(Date.now())), Date.now(), (result) => {
      this.setState({ ingiunzioniAnnue: result });
      this.state.datiIngiunzioni[2] = { ...this.state.datiIngiunzioni[2], generate: result };
      this.setState({ datiIngiunzioni: this.state.datiIngiunzioni, });
      this.setState((prevState)=>{
        return {fetchIngiunzioni:prevState.fetchIngiunzioni+1}
      })
    });
    this.dashboardSanzioneService.getDettagliIncassoByTime((result) => {
      this.setState({
        datiGuadagni: [
          { name: 'Incassato', value: parseInt(result.incassato) / 100 },
          { name: 'Da Incassare', value: parseInt(result.daIncassare) / 100 },
        ]
      });
      this.setState({ totaleDaIncassare: result.daIncassare });
      this.setState({ totaleIncassato: result.incassato });
    });

    let stopLoadingSanzioni = setInterval(()=>{
        this.setState({loadingGraficoSanzioni:false})
        clearInterval(stopLoadingSanzioni)
    },3000)

    let stopLoadingIngiunzioni = setInterval(()=>{
        this.setState({loadingGraficoIngiunzioni:false})
        clearInterval(stopLoadingIngiunzioni)
    },3000)

    this.setState({ loading: false });
  }



  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />

        <div className="container-fluid">
          <small style={{ fontSize: "14px" }} className="mb-2 text-gray-800">
            Dashboard &#8594; Sanzioni
          </small>
          <br />
            <div className="row py-3">
              <div className="col-10 col-xl-6 d-flex flex-column align-items-center">
              <h4 className="ms-4">Dettagli Sanzioni {new Date().getFullYear()}</h4>
                {this.state.fetchSanzioni !==3 ? <LoadSpinner />:
                <BarChart
                  width={500}
                  height={300}
                  data={this.state.datiSanzioni}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="emesse" fill="#FFBA13" />
                </BarChart>
                }
              </div>
              <div className="col-10 col-xl-6 d-flex flex-column align-items-center">
              <h4 className="ms-4">Dettagli Ingiunzioni {new Date().getFullYear()}</h4>
              {this.state.fetchIngiunzioni !== 3 ? <LoadSpinner />:
                <BarChart
                  width={500}
                  height={300}
                  data={this.state.datiIngiunzioni}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="generate" fill="#1358ff" />
                </BarChart>
                }

              </div>
            </div>
            <div className="row py-3">
              <div className="col-10 col-xl-6 d-flex flex-column align-items-center">
              <h4 className="ms-4">Dettagli Incasso {new Date().getFullYear()}</h4>
                <PieChart width={200} height={200}>
                    <Pie
                      data={this.state.datiGuadagni}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={this.renderCustomizedLabel}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {this.state.datiGuadagni.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={this.COLORS[index % this.COLORS.length]} />
                      ))}
                    </Pie>
                  </PieChart>
                  <div className="d-flex gap-3">
                    <span className="fw-bold">Incassati: <span>{(this.state.totaleIncassato / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}</span></span>
                    <span className="fw-bold">Da Incassare: <span>{(this.state.totaleDaIncassare / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}</span></span>
                  </div>
              </div>
              <div className="col-10 col-xl-6"></div>
            </div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
